export type AppDownload = {
  label: string;
  url?: string;
};

export type AppExternalLinks = {
  /** App 内常用入口：管理订阅等 */
  manageSubscription?: {
    ios?: string;
    android?: string;
  };
};

export type AppScreenshot = {
  src: string;
  alt: string;
};

export type AppProject = {
  slug: string;
  name: string;
  shortDescription: string;
  description?: string;
  tags?: string[];
  downloads: {
    ios?: AppDownload;
    android?: AppDownload;
    web?: AppDownload;
  };
  externalLinks?: AppExternalLinks;
  screenshots?: AppScreenshot[];
};

/**
 * App 工厂数据源（可持续维护）
 * - 后续新增项目：只需要在这里追加一条即可自动出现在列表与详情页
 */
export const APP_PROJECTS: AppProject[] = [
  {
    slug: 'pandaspeak',
    name: 'PandaSpeak',
    shortDescription: '语音互动与故事内容体验的移动端应用。',
    description:
      '提供语音互动体验与内容服务，支持在应用内完成核心功能使用，并提供订阅管理入口。官网在此提供下载入口与隐私/EULA 入口，满足上架合规要求。',
    tags: ['iOS', 'Android', 'Voice'],
    downloads: {
      ios: { label: 'App Store 下载', url: 'https://apps.apple.com/app/6467557832' },
      android: { label: 'Android 下载（待补充）' },
      web: { label: 'PandaSpeak 链接', url: 'https://nextjs-speak-story.vercel.app/PandaSpeak' },
    },
    externalLinks: {
      manageSubscription: {
        ios: 'https://apps.apple.com/account/subscriptions',
        android: 'https://play.google.com/store/account/subscriptions',
      },
    },
    screenshots: [
      { src: '/images/apps/pandaspeak/ss-1.webp', alt: 'PandaSpeak 截图 1' },
      { src: '/images/apps/pandaspeak/ss-2.webp', alt: 'PandaSpeak 截图 2' },
      { src: '/images/apps/pandaspeak/ss-3.webp', alt: 'PandaSpeak 截图 3' },
      { src: '/images/apps/pandaspeak/ss-4.webp', alt: 'PandaSpeak 截图 4' },
    ],
  },
];

export function getAppProjectBySlug(slug?: string) {
  if (!slug) return undefined;
  return APP_PROJECTS.find(p => p.slug === slug);
}

